export const getPostBody = ({
  editorStateSelectors
}) => {
  const {
    selectPostBody
  } = editorStateSelectors;
  return selectPostBody();
};